<div class="sk-container" [ngClass]="{ 'sk-loading': state.loading }">
    <outlet-status [state]="state">
        <request-error (reloadFn)="reloadComponent()"></request-error>
    </outlet-status>
    @if (onboardingCoupon && onboardingCoupon.isEnable && showOnboardingOverlay && !isLoading) {
        <div [overscrollFix]="'always'" id="onboarding-overlay" [hidden]="isShowDiv">
            @if (isDisplayed) {
                <a data-uat="popUpCloseButton" class="btn-close" (click)="imageclose('close')">
                    <svg class="btn-colour">
                        <use xlink:href="#close-icon"></use>
                    </svg>
                </a>
            }
            <div class="centered">
                @if (welcomeUrl) {
                    <div class="welcome-card">
                        <div>
                            <img class="image" (load)="isDisplay()" [hidden]="isDisplayed === false" [src]="welcomeUrl | safe: 'resourceUrl'" />
                        </div>
                    </div>
                }
            </div>
            @if (onboardingCoupon && onboardingCoupon.buttonText && isDisplayed) {
                <button class="base-btn" [textContent]="onboardingCoupon.buttonText" (click)="imageclose('CTA')"></button>
            }
        </div>
    }
    @if (!state.loading && !state.error) {
        <div>
            @if (couponName) {
                <top-bar [title]="'Coupons'" (titleFunc)="goToPage('sport/football/coupons')" [innerContent]="true">
                    <top-bar-body class="top-bar-side" data-crlat="topBarContent">
                        @if (isBetFilterEnable && !isEventsUnavailable) {
                            <a [routerLink]="'/bet-filter/filters/your-teams'" class="bet-finder-link" data-crlat="betFilterLink">
                                <svg class="bet-finder-icon">
                                    <use xlink:href="#bet-finder-icon"></use>
                                </svg>
                                <span class="bet-finder-title" data-crlat="title" [i18n]="'bf.betFinder'"></span>
                            </a>
                        }
                    </top-bar-body>
                </top-bar>
            }
            @if (!applyingParams) {
                <div
                    class="top-title title-bg coupons-top-title"
                    id="coupons-dropdown-container-coral-mobile"
                    [hidden]="hideCoupons && !marketFilter"
                    [class.active]="showCoupons"
                    data-crlat="couponsListPageTitle">
                    @if ((!isEventsUnavailable || noEventsDropDown) && marketOptions?.length && isDataRetrieve) {
                        <lazy-component
                            class="sticky-market-selector sticky-market-selector-coral coral-mobile-markets-containter"
                            [hidden]="!marketFilter"
                            [ngClass]="{ 'max-width-adj': isDefaultCoupon }"
                            moduleUri="@sharedModule/components/marketSelector/market-selector.module#MarketSelectorModule"
                            data-crlat="couponType.default"
                            entryComponent="MatchesMarketSelectorComponent"
                            [inputs]="{
                                sportId: couponsDetailsService.sportId,
                                multipleEventsDataSections: couponEvents,
                                marketOptions: marketOptions,
                                toggleTitle: 'MARKET: ',
                                isFromCoupon: true,
                                selectorType: 'footballCoupons',
                            }"
                            [outputs]="['filterChange']"
                            (event)="filterEvents($event.value)">
                        </lazy-component>
                    }
                    @if ((dateCoupons?.length || (coupons?.length && !isDefaultCoupon)) && !isExcludedDate) {
                        <drop-down-menu
                            [ngClass]="{ 'leagues-drp': !isDefaultCoupon }"
                            [hidden]="hideCoupons"
                            class="market-selector-coral coral-mobile-coupon-container datedDrp"
                            [selectedItem]="getCouponFilterName()"
                            [menuList]="isDefaultCoupon ? dateCoupons : coupons"
                            [selectionNameKey]="'name'"
                            [selectionValueKeys]="['name']"
                            [isFromCoupon]="true"
                            (clickFunction)="filterCoupons($event)">
                        </drop-down-menu>
                    }
                </div>
            }

            <loading-screen [displayed]="applyingParams || (hideCoupons && !marketFilter)" [templateType]="'GENERIC'"></loading-screen>
            @if (!applyingParams) {
                <div class="coupons-details-content" data-crlat="tabContent">
                    <div data-crlat="accordionsList" [hidden]="showCoupons">
                        <div class="heuristic-container top-padding coupons-container-js">
                            <lazy-component
                                moduleUri="@lazy-modules-module/twoUpSignpostingBlurbMsg/twoup-signposting-blurbmsg.module#TwoUpSignPostingBlurbMsgModule"
                                [inputs]="{
                                    marketName: selectedMarketSwitcher,
                                }"
                                entryComponent="TwoUpSignPostingBlurbMsgComponent">
                            </lazy-component>
                            @if (couponsDetailsService.isGoalscorerCoupon) {
                                <goalscorer-coupon [couponEvents]="couponEvents" data-crlat="couponType.goalscorer"> </goalscorer-coupon>
                            }
                            @if (couponsDetailsService.isCorrectScoreCoupon && couponEvents?.length) {
                                <correct-score-coupon [couponEvents]="couponEvents"></correct-score-coupon>
                            }
                            @if (
                                !isEventsUnavailable && (marketFilter || couponsDetailsService.isCMSCoupons) && !couponsDetailsService.isCustomCoupon
                            ) {
                                @for (events of couponEvents; let i = $index; track trackByTypeId(i, events)) {
                                    <accordion
                                        [accordionTitle]="events.typeName"
                                        [inner]="true"
                                        [id]="'acc-' + events.typeId"
                                        [isExpanded]="isExpanded[i]"
                                        (function)="changeAccordionState(i, $event)"
                                        [class]="'page-card'">
                                        @if (isExpanded[i]) {
                                            <accordion-body>
                                                @if (!!leagueLinksMap[events.typeId]) {
                                                    <div class="coupons-stats-link">
                                                        <a class="stats-link" (click)="openLeagueTable(events)">
                                                            <svg class="stats-link-icon">
                                                                <use xlink:href="#stats-icon"></use>
                                                            </svg>
                                                            <span class="stats-link-label" [i18n]="'sb.leagueTable'"></span>
                                                        </a>
                                                    </div>
                                                }
                                                @for (
                                                    groupedBy of events.groupedByDate;
                                                    track trackById(dateIndex, groupedBy);
                                                    let dateIndex = $index
                                                ) {
                                                    @if (!groupedBy.deactivated) {
                                                        <div class="container-inner-content" data-crlat="eventsGroupedByDate">
                                                            @if (oddsHeader && oddsHeader.length) {
                                                                <div class="odds-card-header" data-crlat="eventOddsHeader">
                                                                    @if (groupedBy.title) {
                                                                        <div class="odds-left">
                                                                            <span
                                                                                class="odds-header-title"
                                                                                [textContent]="groupedBy.title"
                                                                                data-crlat="dateTitle"></span>
                                                                        </div>
                                                                    }
                                                                    <div class="odds-right">
                                                                        @for (title of oddsHeader; track i; let i = $index) {
                                                                            <span
                                                                                class="odds-header-col"
                                                                                [textContent]="title"
                                                                                data-crlat="headTitles"></span>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            }
                                                            @if (!oddsHeader) {
                                                                <odds-card-header
                                                                    [events]="groupedBy.events"
                                                                    [sportConfig]="footballService?.sportConfig"
                                                                    [dateTitle]="groupedBy.title"
                                                                    [isHeaderAlwaysVisible]="true"
                                                                    [isFilterByTemplateMarketName]="true"
                                                                    [isMarketSwitcherConfigured]="true"
                                                                    [selectedMarket]="marketFilter">
                                                                </odds-card-header>
                                                            }
                                                            @for (
                                                                eventEntity of groupedBy.events;
                                                                track trackById(eIndex, eventEntity);
                                                                let eIndex = $index
                                                            ) {
                                                                <odds-card-component
                                                                    [event]="eventEntity"
                                                                    [sportConfig]="footballService?.sportConfig"
                                                                    data-crlat="eventEntity"
                                                                    [class]="'coupon-event-' + eventEntity.id"
                                                                    [isFilterByTemplateMarketName]="true"
                                                                    [isMarketSwitcherConfigured]="true"
                                                                    [selectedMarket]="events.defaultValue"
                                                                    [isFootballCoupon]="isFootball"
                                                                    [couponIndex]="i"
                                                                    [dateIndex]="dateIndex"
                                                                    [eventIndex]="eIndex"
                                                                    [showBoard]="eventEntity.isCouponScoreboardOpened"
                                                                    (expand)="onExpand($event)">
                                                                </odds-card-component>
                                                            }
                                                        </div>
                                                    }
                                                }
                                            </accordion-body>
                                        }
                                    </accordion>
                                }
                            }
                            <link rel="preload" href="/assets/images/background-coral.webp" as="image" />
                        </div>
                        @if (isEventsUnavailable) {
                            <no-events></no-events>
                        }
                    </div>
                </div>
            }
        </div>
    }
</div>
